<template>
    <div id="subscriptions" />
</template>

<script>
import utils from '../../js/utils';

export default {
    store: [
        'api',
        'user',
        'products',
        'RCproducts'
    ],
    data () {
        return {
            RCInfo: {},
            redirectUrl: '/home'
        };
    },
    mounted: function () {
    },
    created: function () {
        this.$events.on('get-product-from-sku', this.getProductFromSku);
        this.$events.on('subscriptions-sync', this.sync);
        this.$events.on('subscriptions-purchase', this.purchase);
        this.$events.on('subscriptions-restore', this.restore);
        this.$events.on('subscriptions-cancel', this.cancel);
    },
    methods: {
        getProductFromSku: function (sku, cb) {
            console.log('[Subscriptions] getProductFromSku', this.products.length);
            for (let i = 0; i < this.products.length; i++) {
                console.log(sku === this.products[i].sku, this.isForThisPlatform(this.products[i]))
                if (this.products[i].sku === sku && this.isForThisPlatform(this.products[i])) {
                    this.products[i].priceString = `$${(parseFloat(this.products[i].price)).toFixed(2).replace('.00', '')}`;
                    this.products[i].currency = 'USD';
                    if (pgap) {
                        let p = this.RCProduct(this.products[i]);
                        if (p) {
                            let introPrice = ''
                            if (p.product.intro_price && p.product.intro_price_string) {
                                introPrice += `${p.product.intro_price_string} ${p.product.introPrice.intro_price_period_number_of_units} ${p.product.intro_price_period_unit.toLowerCase()}s then `
                            }
                            this.products[i].priceString = `${introPrice}${p.product.price_string}`;
                            this.products[i].currency = p.product.currency_code;
                        }
                    }
                    console.log('[Subscriptions] getProductFromSku', this.products[i]);
                    cb(this.products[i]);
                }
            }
        },
        RCProduct: function (product) {
            for (let i = 0; i < this.RCproducts.current.availablePackages.length; i++) {
                const p = this.RCproducts.current.availablePackages[i];
                if (product.identifier === p.product.identifier) {
                    return p;
                }
            }
            return false;
        },
        sync: function (cb) {
            let completed = 0;
            console.log('[Subscriptions] sync');
            this.$http.get(`${this.api}/subscriptions/products`).then(
                (response) => {

                    for (let i = 0; i < response.body.length; i++) {
                        const product = response.body[i];
                        product.eligibleForTrial = true;
                        // this code is not working
                        // if (pgap) {
                        //     product.eligibleForTrial = this.exiligbleForTrial(product);
                        // }
                    }
                    this.products = response.body;
                    console.log('[Subscriptions] synced', this.products);
                    completed++;
                    if (!pgap) {
                        if (typeof cb !== 'undefined') cb();
                    } else {
                        if (typeof cb !== 'undefined' && completed === 2) cb();
                    }
                },
                (response) => {
                    f7.dialog.alert(response.body ? response.body.message : 'Unknown error');
                    completed++;
                    if (!pgap) {
                        if (typeof cb !== 'undefined') cb();
                    } else {
                        if (typeof cb !== 'undefined' && completed === 2) cb();
                    }
                }
            );

            if (pgap) {
                window.Purchases.getOfferings(
                    offerings => {
                        this.RCproducts = offerings;
                        console.log('[RC] offerings', offerings);
                        completed++;
                        if (typeof cb !== 'undefined' && completed === 2) cb();
                    },
                    (error) => {
                        completed++;
                        if (typeof cb !== 'undefined' && completed === 2) cb();
                        console.error('[RC] offerings', error);
                    }
                );
            }

            this.$http
                .get(this.api + '/subscriptions/status')
                .then(() => {
                    this.$http.get(this.api + '/users/me').then(
                        response => {
                            this.user = response.body;
                            if (pgap && this.user.id) {
                                window.Purchases.getPurchaserInfo(
                                    info => {
                                        this.RCInfo = info;
                                        console.log('[Subcription][RC] info', info);
                                        const plusActiveInOldSystem = this.user.isSubscribed;
                                        const plusActiveInRevenueCat = typeof info.entitlements.active.Subscription !== "undefined";
                                        // If the old system says we have a subscription, but RevenueCat does not
                                        if (plusActiveInOldSystem && !plusActiveInRevenueCat) {
                                            // Tell Purchases to restoreTransactions. 
                                            // This will sync the user's receipt with RevenueCat.
                                            window.Purchases.restoreTransactions();
                                            console.log('[Subcription][RC] restore', plusActiveInRevenueCat);
                                        }
                                    },
                                    error => {
                                        console.error('[Subcription][RC] info', error);
                                    }
                                );
                            }
                        });
                }, () => {
                    console.error('[Subcription] could not get status');
                })
        },
        isForThisPlatform: function (product) {
            if (pgap && ['app_store', 'play_store'].indexOf(product.provider) > -1) {
                // is mobile
                if (product.provider === 'app_store' && device.platform === 'iOS') {
                    return true;
                }
                if (product.provider === 'play_store' && device.platform === 'Android') {
                    return true;
                }
                return false;
            }
            if (!pgap && product.provider === 'stripe') {
                // is web
                if (this.paymentMode === 'sandbox' && product.sandbox) {
                    return true;
                }
                if (this.paymentMode !== 'sandbox' && !product.sandbox) {
                    return true;
                }
                return false;
            }
            return false;
        },
        exiligbleForTrial: function (product) {
            // is this not working
            window.Purchases.checkTrialOrIntroductoryPriceEligibility(
                [product.identifier, "Subscription"],
                map => {
                    // f7.popup.create({
                    //     content: `<div class="popup" style="overflow-y: scroll;"><br><br><p><a href="#" class="link popup-close">Close admin detail</a></p>
                    //                 <pre>${JSON.stringify(map, null, 2)}</pre></div>`,
                    // }).open();
                    if (map && map[product.identifier] && map[product.identifier].status === 1) {
                        return false;
                    }
                    return true;
                }
            );
        },
        purchase: function (product) {
            // takes a coral product
            if (!product || !this.isForThisPlatform(product)) {
                return f7.dialog.alert('An invalid product was specified.');
            }
            if (pgap) {
                this.doPayNative(product);
            } else {
                this.doPayStripe(product);
            }
        },
        doPayNative: function (product) {
            if (this.isProcessing) return;
            console.log('doPayNative');
            this.isProcessing = true;
            f7.preloader.show();
            let pckage = {};
            for (let i = 0; i < this.RCproducts.current.availablePackages.length; i++) {
                const element = this.RCproducts.current.availablePackages[i];
                if (element.product.identifier === product.identifier) {
                    pckage = element;
                }
            }
            // if (this.user.id === 1) {
            //     f7.popup.create({
            //         content: `<div class="popup" style="overflow-y: scroll;"><br><br><p><a href="#" class="link popup-close">Close admin detail</a></p>
            //                         <pre>${JSON.stringify(this.RCproducts.current.availablePackages, null, 2)}</pre></div>`,
            //     }).open();
            // }
            window.Purchases.purchasePackage(
                pckage,
                info => {
                    f7.preloader.hide();
                    if (info.purchaserInfo.activeSubscriptions.length > 0) {
                        this.$http
                            .post(this.api + '/subscriptions/mobile', {
                                platform: device.platform,
                                productId: product.id,
                                latestExpirationDate: info.purchaserInfo.latestExpirationDate,
                                price: product.price, // actual price paid by user
                                currency: product.currency, // actual price paid by user
                            })
                            .then(
                                (response) => {
                                    this.setSubscription('Paid', {
                                        transactionId: response.body.transactionId,
                                        store: device.platform === 'Android' ? 'play_store' : 'app_store',
                                        price: product.price, // actual price paid by user
                                        currency: product.currency, // actual price paid by user
                                    }, product);
                                },
                                data => {
                                    console.error(data);
                                }
                            );
                    } else {
                        f7.dialog.alert('Something went wrong.');
                    }
                },
                (error, userCancelled) => {
                    console.error('Error making purchase', error);
                    f7.preloader.hide();
                    if (error.error && !userCancelled)
                        f7.dialog.alert(error.error.message + '<br>' + error.error.underlyingErrorMessage, 'Error');
                    else if (!userCancelled)
                        f7.dialog.alert('Something went wrong', 'Error');
                },
                null,
                'subs'
            ); // Optional: Pass "subs" for subscriptions, "inapp" for non-subscriptions (e.g. consumables). Needed for Android, iOS will ignore this.
        },
        doPayStripe: function (product) {
            const handler = window.StripeCheckout.configure({
                key: this.paymentMode === 'sandbox' ? 'pk_test_miZaqNTG6vFxiJ9p83P5rbnb00VKuAfXoV' : 'pk_live_7TVU7AXJvUMiCGAM0OcrQzh6003r0bobq6',
                // key: 'pk_live_',
                // image: 'https://alphaplay.com/app/images/logo.png',
                locale: 'auto',
                token: token => {
                    f7.preloader.show();
                    // You can access the token ID with `token.id`.
                    // Get the token ID to your server-side code for use.
                    this.$http
                        .post(this.api + '/subscriptions/stripe', {
                            token: token,
                            productId: product.id,
                            price: parseFloat(product.price),
                            currency: 'USD',
                        })
                        .then(
                            response => {
                                console.log('stripe subscription ok', response.body);
                                f7.preloader.hide();
                                this.setSubscription('Paid', {
                                    transactionId: response.body.transactionId,
                                    store: 'stripe',
                                    price: parseFloat(product.price),
                                    currency: product.currency,
                                }, product);
                            },
                            data => {
                                f7.preloader.hide();
                                f7.dialog.alert(`You have not been charged. ${data.body && data.body.message ? data.body.message : ''}`, 'Something went wrong.');
                                console.error(data);
                            }
                        );
                }
            });
            handler.open({
                name: 'Coral',
                description: product.description,
                zipCode: true,
                currency: 'usd',
                amount: parseFloat(product.price) * 100,
                // image: 'https://alphaplay.com/app/images/logo.png',
                allowRememberMe: false,
                email: this.user.email
            });
            // Close Checkout on page navigation:
            window.onpopstate = () => {
                handler.close();
            };
        },
        restore: function () {
            if (this.user.isSubscribed) return f7.dialog.alert('Already subscribed');
            window.Purchases.restoreTransactions(
                purchaserInfo => {
                    console.log('restore purchases ok ', purchaserInfo);
                    if (purchaserInfo &&
                        purchaserInfo.activeSubscriptions &&
                        purchaserInfo.activeSubscriptions.length > 0) {
                        this.setSubscription('Paid');
                    } else {
                        f7.dialog.alert('Nothing to restore');
                    }
                },
                error => {
                    f7.dialog.alert(error.message, 'Error restoring purchases');
                    console.error('error restoring purchases', error);
                }
            );
        },
        cancel: function () {
            if (!this.user.isSubscribed) return f7.dialog.alert('Cannot cancel, you are not subscribed.')
            if (this.user.subscriptionMethod === 'stripe') {
                f7.dialog.confirm(`Danger! Danger! 
                Choosing yes will cancel your subscription immediately. 
                Are you sure you want to do that?`, () => {
                    this.$http.delete(`${this.api}/subscriptions/stripe`).then(
                        () => {
                            this.setSubscription('Free');
                            f7.dialog.alert('Your subscription is cancelled.', 'Success!');
                        },
                        e => {
                            f7.dialog.alert('Something went wrong, could not cancel.');
                            console.error('error complete day', e);
                        }
                    );
                });
            } else if (this.user.subscriptionMethod === 'promotional' || this.user.subscriptionMethod === 'beta') {
                f7.dialog.confirm(`Danger! Danger! 
                Choosing yes will cancel your subscription immediately. 
                Are you sure you want to do that?`, () => {
                    this.$http.delete(`${this.api}/subscriptions/coupon`).then(
                        () => {
                            this.setSubscription('Free');
                            f7.dialog.alert('Your subscription is cancelled.', 'Success!');
                        },
                        e => {
                            console.error('error complete day', e);
                            f7.dialog.alert('Something went wrong, could not cancel.');
                        }
                    );
                });
            } else if (this.user.subscriptionMethod === 'app_store') {

                // https://support.apple.com/en-gb/HT202039
                window.open('itms-apps://apps.apple.com/account/subscriptions', '_system');
                setTimeout(() => {
                    this.sync();
                }, 30 * 1000);

            } else if (this.user.subscriptionMethod === 'play_store') {

                // https://support.google.com/googleplay/answer/7018481
                window.open('https://play.google.com/store/account/subscriptions', '_system', '');
                setTimeout(() => {
                    this.sync();
                }, 30 * 1000);

            } else if (['promotional', 'partner'].indexOf(this.user.subscriptionMethod) > -1 && this.user.subscriptionId === 'PARTNER') {
                f7.dialog.alert('Cannot cancel your subscription as it is FREE and linked to your partner. Unlink your partner to cancel.')
            } else {
                f7.dialog.confirm('Are you sure you want to cancel your subscription?', () => {
                    if (pgap) {
                        if (device.platform === 'iOS') {

                            window.open('https://support.apple.com/en-gb/HT202039', '_system');
                            setTimeout(() => {
                                this.sync();
                            }, 20 * 1000);

                        } else if (device.platform === 'Android') {
                            window.open('https://play.google.com/store/account/subscriptions', '_system', '');
                            setTimeout(() => {
                                this.sync();
                            }, 20 * 1000);

                        } else {
                            f7.dialog.alert('Unable to cancel as we were unable to determine which store you are subscribed with. Please contact support.')
                        }
                    }
                });
            }
        },
        setSubscription: function (type, data, product) {
            if (type === 'Paid') {
                this.sync(
                    () => {
                        f7.dialog.alert('You\'re on the path to your best intimate life.', 'Congratulations!');
                        this.user.isSubscribed = true;
                        this.$events.fire('trackEvent', 'af_trial_converted');

                        this.$events.fire('user-save', () => {
                            if (data && data.transactionId && !product.sandbox) {
                                let info = {};
                                if (data && product) {
                                    info = {
                                        id: data.transactionId,
                                        subscription_product_id: product.id,
                                        subscription_sku: product.sku,
                                        name: product.sku,
                                        price: data.price,
                                        currency: data.currency,
                                    }
                                }
                                this.$events.fire('newSubscriber', info);
                            }
                            if (this.redirectUrl !== '/home') {
                                f7.views['main'].router.navigate({
                                    url: '/home',
                                    transition: 'f7-fade',
                                    reloadPrevious: true
                                });
                            }
                            f7.views['main'].router.navigate({
                                url: this.redirectUrl,
                                transition: 'f7-fade',
                                reloadCurrent: true
                            });
                        });
                    }
                );
            } else {
                this.user.isSubscribed = false;
                f7.dialog.alert('You are now unsubscribed.');
                f7.views['main'].router.navigate('/home');
            }
        },
    }
};
</script>
<style lang="less" scoped>
#subscriptions {
    display: hidden;
}
</style>
